module.exports = __webpack_public_path__ + "img/icon-delete-4.085f8d2a.svg";